<template lang="pug">
.filter-date-range
  .selects(v-if='filter.selects')
    filter-select(:filter='filter.selects', v-model='inner_select')

  .pickers(:class='{disabled: !picker_enabled}')
    datepicker.start(:value='inner_start', @input='input_start', :disabled='!picker_enabled')
    .separator.ui.button.icon(@click='start_to_end')
      i.icon.right.angle.double
    datepicker.end(:value='inner_end', @input='input_end', :disabled='!picker_enabled')
</template>

<script>
import { Datepicker } from '../basic'
import FilterSelect from './FilterSelect.vue'

export default {
  name: 'filter-date-range',
  components: { Datepicker, FilterSelect },
  props: {
    value: { type: String, default: null },
    filter: { type: Object, required: true },
    disabled: { type: Boolean, default: false },
    preset: { type: String, default: 'default' },
    start: null,
    end: null,
    select: null,
  },
  data() {
    return {
      inner_select: null,
      inner_result: null,
      inner_start: null,
      inner_end: null,
      picker_enabled: false,
    }
  },
  computed: {
    field() {
      if (this.filter)
        return this.filter.field || 'time_created'
      return 'time_created'
    },
  },
  watch: {
    start(to, from) {
      if (!to || !from || +to !== +from) // Convert date to timestamp
        this.init()
    },
    end(to, from) {
      if (!to || !from || +to !== +from) // Convert date to timestamp
        this.init()
    },
    inner_select(to) {
      if (to === null)
        this.picker_enabled = false
      else
        this.picker_enabled = true
      if (to === 'today')
        this.inner_start = this.inner_end = this.$moment().startOf('days')
      else if (to === 'yesterday')
        this.inner_start = this.inner_end = this.$moment().startOf('days').subtract(1, 'days')
      else if (to === 'thisweek') {
        this.inner_start = this.$moment.utc().startOf('weeks')
        this.inner_end = this.$moment.utc().startOf('weeks').add(1, 'weeks').subtract(1, 'days')
      } else if (to === 'thismonth') {
        this.inner_start = this.$moment.utc().startOf('months')
        this.inner_end = this.$moment.utc().startOf('months').add(1, 'months').subtract(1, 'days')
      } else if (to === 'lastmonth') {
        this.inner_start = this.$moment.utc().subtract(1, 'months').startOf('months')
        this.inner_end = this.$moment.utc().startOf('months').subtract(1, 'days')
      }

      this.update()
    },
  },
  created() {
    this.init()
  },
  methods: {
    update() {
      this.$emit('update:select', this.inner_select)
      this.$emit('update:start', this.inner_start)
      this.$emit('update:end', this.inner_end)
      this.$emit('filter')
    },
    init() {
      this.inner_select = this.select
      this.inner_start = this.start || this.$moment().startOf('day')
      this.inner_end = this.end || this.$moment().startOf('day')
      this.$emit('filter')
    },
    $filter(data) {
      if (this.inner_select === null)
        return data

      return data.filter(r => {
        const date = this.$moment(r[this.field])
        return +this.$moment(this.inner_start).startOf('day') <= +date 
          && +date <= +this.$moment(this.inner_end).endOf('day')
      })
    },
    input_start(value) {
      // Manual pick time
      this.inner_select = 'custom'
      this.inner_start = value 

      if (this.inner_start > this.inner_end) 
        this.inner_end = this.inner_start

      this.update()
    },
    input_end(value) {
      this.inner_select = 'custom'
      this.inner_end = value

      if (this.inner_end < this.inner_start) 
        this.inner_start = this.inner_end

      this.update()
    },
    start_to_end() {
      this.inner_select = 'custom'
      this.inner_end = this.inner_start
      this.update()
    },
  },
}
</script>



// WEBPACK FOOTER //
// FilterDateRange.vue?958c56cc